module.exports = __webpack_public_path__ + "img/autumn.0c1b5cb0.jpg";